import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roles-edit',
  templateUrl: './roles-edit.component.html',
  styleUrls: ['./roles-edit.component.css']
})
export class RolesEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
